<script setup lang="ts">
import { useToastStore } from '@/stores/toast'

const toast = useToastStore()

const variantStyles: Record<string, string> = {
  default: 'border-l-2 border-primary',
  success: 'border-l-2 border-status-on-scene',
  error: 'border-l-2 border-error',
  warning: 'border-l-2 border-status-rtb',
}

const variantTextStyles: Record<string, string> = {
  default: 'text-on-surface',
  success: 'text-status-on-scene',
  error: 'text-error',
  warning: 'text-status-rtb',
}
</script>

<template>
  <Teleport to="body">
    <div
      v-if="toast.toasts.length"
      class="fixed bottom-4 left-4 z-[100] flex flex-col gap-2 w-80"
      aria-live="polite"
      aria-label="Notifications"
    >
      <TransitionGroup
        enter-active-class="transition-all duration-200"
        enter-from-class="opacity-0 -translate-x-4"
        enter-to-class="opacity-100 translate-x-0"
        leave-active-class="transition-all duration-150"
        leave-from-class="opacity-100 translate-x-0"
        leave-to-class="opacity-0 -translate-x-4"
      >
        <div
          v-for="t in toast.toasts"
          :key="t.id"
          :class="['bg-surface-container-high border border-border rounded px-4 py-3 shadow-xl flex items-start justify-between gap-3', variantStyles[t.variant]]"
          role="status"
        >
          <p :class="['font-mono text-xs leading-relaxed', variantTextStyles[t.variant]]">
            {{ t.message }}
          </p>
          <button
            class="shrink-0 text-outline hover:text-on-surface transition-colors mt-0.5"
            aria-label="Dismiss"
            @click="toast.remove(t.id)"
          >
            <span class="material-symbols-outlined text-[16px]">close</span>
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>
